import IDMGlobals from '../IDMGlobals';
import IDMUtils from '../IDMUtils';
import { getUrlParams } from 'query-string-manipulator';
const base64 = require('base-64');
/**
 *
 */
export default class IDMExternalProvider {
  /**
   * constructor - description
   *
   * @param  {type} datasource description
   * @return {type}            description
   */
  constructor(datasource) {
    this.datasource = datasource
    this.isLoading = true
    this.enabledClients = {}
    if (!IDMUtils.isNodeJS()) this._loadExternalProviders()
  }
  /* Public */
  //
  isGoogleAvailable() {
    return !!this.enabledClients['GOOGLE']
  }
  isFacebookAvailable() {
    return !!this.enabledClients['FACEBOOK']
  }
  isAppleAvailable() {
    return !!this.enabledClients['APPLE']
  }
  isAzureAvailable() {
    return !!this.enabledClients['AZURE']
  }
  isExternalProvidersEnabled() {
    return this.isGoogleAvailable() || this.isAppleAvailable() || this.isFacebookAvailable() || this.isAzureAvailable()
  }
  //
  async loginWithAzure(optionalPostLoginURL, keepQueryContext = true) {
    if (!this.isAzureAvailable()) return false
    //Persitent context logic
    const v = getUrlParams(window.location.href)
    const suffix = v && v.length > 0 && keepQueryContext ? base64.encode(JSON.stringify(v)) : ''
    //Init oauth
    const resp = await this.datasource.api.externalProvider.getAzureAuthorizationURL(
      optionalPostLoginURL || window.location.origin,
      suffix
    )
    if (resp && resp.statusCode == 200 && resp.body.url) {
      window.location = resp.body.url
      return true
    } else return false
  }
  async loginWithGoogle(optionalPostLoginURL, keepQueryContext = true) {
    if (!this.isGoogleAvailable()) return false
    //Persitent context logic
    const v = getUrlParams(window.location.href)
    const suffix = v && v.length > 0 && keepQueryContext ? base64.encode(JSON.stringify(v)) : ''
    //Init oauth
    const resp = await this.datasource.api.externalProvider.getGoogleAuthorizationURL(
      optionalPostLoginURL || window.location.origin,
      suffix
    )
    if (resp && resp.statusCode == 200 && resp.body.url) {
      window.location = resp.body.url
      return true
    } else return false
  }
  async loginWithFacebook(optionalPostLoginURL, keepQueryContext = true) {
    if (!this.isFacebookAvailable()) return false
    //Persitent context logic
    const v = getUrlParams(window.location.href)
    const suffix = v && v.length > 0 && keepQueryContext ? base64.encode(JSON.stringify(v)) : ''
    //Init oauth
    const resp = await this.datasource.api.externalProvider.getFacebookAuthorizationURL(
      optionalPostLoginURL || window.location.origin,
      suffix
    )
    if (resp && resp.statusCode == 200 && resp.body.url) {
      window.location = resp.body.url
      return true
    } else return false
  }
  async loginWithApple(optionalPostLoginURL, keepQueryContext = true) {
    if (!this.isAppleAvailable()) return false
    //Persitent context logic
    const v = getUrlParams(window.location.href)
    const suffix = v && v.length > 0 && keepQueryContext ? base64.encode(JSON.stringify(v)) : ''
    //Init oauth
    const resp = await this.datasource.api.externalProvider.getAppleAuthorizationURL(
      optionalPostLoginURL || window.location.origin,
      suffix
    )
    if (resp && resp.statusCode == 200 && resp.body.url) {
      window.location = resp.body.url
      return true
    } else return false
  }
  /* Private */
  async _loadExternalProviders() {
    this.isLoading = true
    //Load IDs
    await this._loadExternalProvidersIDs()
    //Stop loading + notify
    this.isLoading = false
    if (this.datasource.sessionExternalProviderLoadedHandler)
      this.datasource.sessionExternalProviderLoadedHandler()
  }
  /* private API/cache */
  async _loadExternalProvidersIDs() {
    //Attempt to load previously saved
    const savedEPs = await this.datasource.session.data.getExternalProviders()
    if (savedEPs) {
      this.enabledClients = savedEPs
      return
    }
    //Attempt to load
    const resp = await this.datasource.api.externalProvider.get()
    if (resp.statusCode == 200) {
      this.enabledClients = resp.body
      await this.datasource.session.data.saveExternalProviders(resp.body)
      return
    }
    //Reset
    this.enabledClients = {}
  }
}
